import axios, { AxiosResponse } from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";
import { MAX_SERVER_REQUESTS_ERROR } from "./OtpVerifyRegisterWithBankAccount";

export const NO_VALID_PHONE_AND_EMAIL = "NO_VALID_PHONE_AND_EMAIL";
export const MEMBER_ALREADY_REGISTERED_ERROR =
  "MEMBER_ALREADY_REGISTERED_ERROR";
export const CONTACT_DETAILS_NOT_FOUND_AND_ISPENSIONER = "Contact_Details_Not_Found_And_IsPensioner";

export async function OtpSendRegister(userId: string, idDate: string) {
  if (userId?.length && idDate?.length) {
    try {
      const body = {
        memberID: userId,
        issueDate: idDate,
      };
      const path = environment.BASE_URL + "MemberRegister/OTPSendRegister";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (axiosUtil.isSuccess(res))
        return {
          otpMode: res.data.otpMode,
          cellPhoneNumber: res.data.cellPhoneNumber,
          email: res.data.email,
          registerBankAccountTokenNum: res.data.registerBankAccountTokenNum,
        } as OtpSendRegisterResult;
      // handle no valid phone or email case
      if (res?.data?.errorCode === 46) return NO_VALID_PHONE_AND_EMAIL;
      if (res?.data?.errorCode === 36) return MAX_SERVER_REQUESTS_ERROR;
      if (res?.data?.errorCode === 43) return MEMBER_ALREADY_REGISTERED_ERROR;
      if (res?.data?.errorCode === 122) return {
        otpMode: res.data.otpMode,
        cellPhoneNumber: res.data.cellPhoneNumber,
        email: res.data.email,
        registerBankAccountTokenNum: res.data.registerBankAccountTokenNum,
      } as OtpSendRegisterResult;

      return {} as OtpSendRegisterResult;
    } catch (err) {
      console.log(err);
    }
  }
  return {} as OtpSendRegisterResult;
}

export const otpSendRegisterUtil = {
  isSuccess: (isOtpSended: OtpSendRegisterResult | string) =>
    typeof isOtpSended === "object" && Object.keys(isOtpSended).length && isOtpSended.registerBankAccountTokenNum == null ,

  isNoValidPhoneAndEmailError: (isOtpSended: OtpSendRegisterResult | string) =>
    typeof isOtpSended === "string" && isOtpSended === NO_VALID_PHONE_AND_EMAIL,

  isPensioner: (isOtpSended: OtpSendRegisterResult | string) =>
  typeof isOtpSended === "string" && isOtpSended === CONTACT_DETAILS_NOT_FOUND_AND_ISPENSIONER,

  isMaxServerRequestsError: (isOtpSended: OtpSendRegisterResult | string) =>
    typeof isOtpSended === "string" &&
    isOtpSended === MAX_SERVER_REQUESTS_ERROR,

  isAlreadyRegisteredError: (isOtpSended: OtpSendRegisterResult | string) =>
    typeof isOtpSended === "string" &&
    isOtpSended === MEMBER_ALREADY_REGISTERED_ERROR,
};

export interface OtpSendRegisterResult {
  otpMode: string;
  cellPhoneNumber: string;
  email: string;
  registerBankAccountTokenNum:string
}
